import { AppRouteProps } from "@harea/component";
import { AuthRoutes } from "@harea/login";
import { UserDetailsRoutes, UserManagementRoutes } from "@harea/user-management";
import { ProjectRoutes } from "@harea/project";
import AdminLayout from "components/layout/AdminLayout";
import AuthLayout from "components/layout/AuthLayout";
import ClientLayout from "components/layout/ClientLayout";
import OrganisationAccessLayer from "container/OrganisationAccessLayer";
import HareaContainer from "container/HareaContainer";
import { UserAuthRoutesTest } from "./auth/UserAuthRoutes";
import { HomeRoutes } from "./home/HomeRoutes";
import { ContractRoutes } from "@harea/contract";
import { PayrollRoutes } from "@harea/payroll";
import { PayingRoutes } from "@harea/billing";
// import { PayslipRoutes } from "@harea/payslip";
import { NotificationRoutes } from "@harea/notification";
import { TranslationRoutes } from '@harea/translation'
import { StaticPageRoutes } from "@harea/static-page"
import Page404 from "./error/Page404";
import { DataExports } from "./data/DataRoutes"
import { DashboardRoutes } from "./dashboard/DashboardRoutes";
import { AppLayout } from "layouts/AppLayout";
import { HistoryRoutes } from "./history/HistoryRoutes";
import { DocumentRoutes } from "@harea/document"
import { TimeoffsRoutes } from "./timeoffs/TimeoffsRoutes"
import { DebauchageRoutes } from "./debauchage/DebauchageRoutes"
// import {PublicStaticPageContainer} from "@harea/static-page";

export const HareaRoutes: Array<AppRouteProps> = [
  {
    path: ":lang",
    title: `std_home`,
    element: <HareaContainer />,
    children: [
      {
        path: "admin",
        element: <AppLayout />,
        children: [
          ...DashboardRoutes,
          // ...TimeoffsRoutes,
          ...ProjectRoutes,
          ...ContractRoutes,
          ...PayingRoutes,
          ...NotificationRoutes,
          ...UserManagementRoutes,
          ...StaticPageRoutes,
          ...TranslationRoutes,
          ...DataExports,
          ...PayrollRoutes,
          ...HistoryRoutes,
          ...DocumentRoutes,
          ...DebauchageRoutes,
        ],
      },
      {
        element: <AuthLayout />,
        children: [
          ...UserAuthRoutesTest,
          ...AuthRoutes.filter((item) => item.path === "logout"),
        ],
      },
      {
        path: "*",
        element: <Page404 />,
      },
    ],
  },
];
